import { getPostsWidgetConfigs } from '../../components/Sections/PostsSection/postsWidgetConfigs';
import {
  getCommonSectionInitActions,
  getCustomInitActionsForWidgets,
  getPageInfoInitActions,
} from './common';

export function getPostsSectionInitActions(responseData, requestParams) {
  return [
    ...getCommonSectionInitActions(responseData, requestParams, 'posts'),
    ...getPageInfoInitActions(responseData, requestParams),
  ].filter(action => action);
}

// new grusers
export const getCustomInitActionsForPostWidgets = (
  responseData,
  requestParams
) => [
  ...getCustomInitActionsForWidgets(
    responseData,
    requestParams,
    getPostsWidgetConfigs({ t: () => null, dispatch: () => null })
  ),
  ...getPageInfoInitActions(responseData, requestParams),
];
